import React, { useState } from 'react';
import { NumberVerification } from '../../pages';
import { MimaToastUtil } from '../../components';
import { businessStore } from '../../stores';
import { BusinessController } from '../../controllers';
import constant from '../../utils/constant';
import * as yup from 'yup';

const NumberVerificationContainer = ({ closeModal }) => {
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState("NUMB");

    const validationSchema = yup.object().shape({
        mobile: yup.string().min(8).required("Enter valid phone number")
    });


    const sendToken = async (value) => {
        setLoading(true);
        const payload = {
            mobile: value.mobile
        }
        const { status, errorMessage } = await BusinessController.sendToken(payload);
        if (status === constant.Success) {
            businessStore.setBusinessMobile(payload.mobile);
            setLoading(false);
            MimaToastUtil.success({
                message: "Token sent to entered phone number"
            })
        }
        setPage("TOKEN");
    }

    const handleOtpSubmit = async (values) => {
        let query
        query = `smsToken=${values.smsToken}&mobile=${businessStore.businessMobile}`
        setLoading(true);
        const { status, errorMessage } = await BusinessController.verifyToken(query);
        if (status === constant.Success) {
            setLoading(false);
            MimaToastUtil.success({
                message: "Token verified successfully"
            })
            return closeModal();
        }
        setLoading(false);
        return MimaToastUtil.error({
            message: errorMessage,
        });
    }

    return (
        <NumberVerification
            sendToken={sendToken}
            handleOtpSubmit={handleOtpSubmit}
            page={page}
            loading={loading}
            closeModal={closeModal}
            validationSchema={validationSchema}
        />
    )
}
export default NumberVerificationContainer;